import React from 'react';
import ChallengeDetails from '@/src/components/challenges/ChallengeDetails';

export const ChallengeDetailsPage: React.FC = () => {
  return <ChallengeDetails />;
};
